var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-cta-table',{attrs:{"title":"Priceperiods","headers":_vm.headers,"storeNamespace":"services","listNamespace":"A_priceperiod","buttonText":"New priceperiod","hideTitle":true},scopedSlots:_vm._u([{key:"row.price_normal",fn:function(ref){
var entity = ref.entity;
return [_vm._v(" "+_vm._s(entity.price_normal)+" "+_vm._s(entity.price_currency)+" ")]}},{key:"dialog-content",fn:function(ref){
var setDialog = ref.setDialog;
return [_c('priceperiod-form',{attrs:{"listOnSave":true},on:{"requestIsDone":function($event){return setDialog(false)}}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }